<div class="flex flex-row">
  <app-toolbar [items]="breadcrumbItems" class="w-100-percent"></app-toolbar>
</div>

<div class="top-panel p-24 m-24 flex flex-row justify-start items-center" *ngIf="!isLoading">
  <mat-icon svgIcon="arrow_back" class="cursor-pointer icon-lg" (click)="goToInstances()"></mat-icon>
  <div class="icon-border mr-16 ml-16 p-12">
    <img src="/assets/images/combined_shape.png" class="icon-lg" alt="Instance">
  </div>
  <div class="flex flex-col">
    <div class="mat-headline-5 mb-6 fw-700">{{ data?.tenantId | titlecase}}</div>
    <div class="mat-body fw-500 fs-16" *ngIf="data?.solution?.name">
      <span class="pr-4">{{'INSTANCE_DETAILS.SOLUTION' | transloco }}:</span>
      {{ solution?.name ?  solution?.name : '-'}}</div>
  </div>
</div>

<app-instance-details *ngIf="data"
  [data]="data" 
  [solution]="solution"
  [isLoading]="isLoading" 
  [instanceDetailsKeys]="instanceDetailsKeys"
  ></app-instance-details>

<mat-card *ngIf="isLoading" class="spinner flex flex-row justify-center items-center">
  <mat-spinner diameter="24"
               color="primary"
               mode="indeterminate">
  </mat-spinner>
</mat-card>

